import type { OptimizelySdk, OptimizelyUserInfo } from '@/main/lib/providers/OptimizelyProvider';
import { createContext, useContext } from 'react';

type OptimizelyContextType = {
  userFlags: OptimizelyUserInfo;
  optimizely: OptimizelySdk | null;
};

export const OptimizelyContext = createContext<OptimizelyContextType>({
  userFlags: {},
  optimizely: null,
});

export const useOptimizely = () => useContext(OptimizelyContext);
